import React, { Component } from 'react';
import _ from 'lodash';
import { Chart } from "react-google-charts";
class ComponentToPrint extends React.Component {
    addCharts=(tab)=>{
        const uuidv1 = require('uuid/v1');
        let datas = [['Task', 'Percentage']];
            tab.segments.map(segment=>{

                datas.push([`${segment.name}`, segment.percent])

            })
            return <Chart
            width={'700px'}
            height={'400px'}
            chartType="PieChart"
            loader={<div>Loading Chart</div>}
            data={datas}
            options={{
                is3D: true,
                chartArea: {
                    left: 0,
                    top: 20,
                    width: "100%",
                    height: "100%"
                },
                legend: {
                    position: "labeled"
                }
            }}
            graph_id={uuidv1()}
        />


    }
    render() {
        return (
            <div style={{ width: "930px", padding: '20px 0px 0px 30px' }}  id="chartPrint">
                <h2 style={{ fontSize: "18px", color: "#333333", margin: "0px 0px 0px 0px" }}>Results</h2>

                <br />
                {this.props.tabs.map((tab,key) => {
                    return <div style={{ marginBottom: "20px" }} key={key}>
                        <div>
                            <div style={{width: "fit-content",padding: "10px", marginBottom: "15px", background: "#f2f2f2",marginLeft: '10px',border: 'none'}}>
                                <span style={{fontWeight: "bold", color:"#000", border: "none"}}>{tab.groupName}</span>
                            </div>
                        </div>
                        <div style={{width: "700px"}}>
                            {this.addCharts(tab)}
                        </div>
                    </div>
                })}
            </div>
        );
    }
}
export default (ComponentToPrint);



// WEBPACK FOOTER //
// ./src/components/Segmentation/Results/ComponentToPrint/ComponentToPrint.jsx